import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import Styles from './Modal.scss';

const ModalHeader = (props) => {
    const { id, onCancel, isCancelDisabled, title } = props;

    return (
        <div className={Styles.modalHeader}>
            <span
                id={id}
                role="modal-header-title"
                style={{ overflowY: 'hidden', textWrap: 'wrap' }}
            >
                {title}
            </span>
            {/* <IconButton
                size='small'
                onClick={onCancel}
                sx={{ color: "#fff" }}
                disabled={isCancelDisabled}
                role='modal-header-close-btn'
            >
                <CloseIcon /> */}
            {/* </IconButton> */}
        </div>
    );
};

ModalHeader.propTypes = {
    id: PropTypes.string,
    onCancel: PropTypes.func,
    isCancelDisabled: PropTypes.bool,
    title: PropTypes.string,
};
export default ModalHeader;
